<!-- Translated: yes -->
<template>
  <div>
    <div :class="'pretty-order ' + order.status">
      <div v-if="orderTypeSingle === 'accomodation'">
        <div v-for="row in order.details.rows.accomodation" :key="row.rowid">
          <div v-if="row.accommodation" class="accommodation">
            <div class="accommodation-image" :style="(row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image) ) ? 'background-image:url(' + (row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image) ) + ')' : 'background-size: cover;'">
            </div>

            <div class="booking-facts">
              <p class="booking-id">
                Bokningsnummer: {{ order.resvid }}
              </p>

              <p class="booking-title">
                {{ row.accommodation.display_name || row.accommodation.description_title }}<span v-if="row.accommodation.subtitle"> – {{row.accommodation.subtitle}}</span>
              </p>

              <p class="arrival-date">
                {{[order.details.firstDate, order.details.lastDate] | dateRange('long', ' – ')}}
              </p>

              <div class="spacer" style="margin-top:1.5rem;"></div>

              <button class="button--rounded" @click.stop="goToBooking(order.headlid)">Visa bokning</button>
            </div>

            <!-- <div class="accommodation-facts">

              Tillvalslista
              <div v-if="order.details.can_add_to_booking && SITE_CONFIG.add_to_booking_open">
                <button class="white border button-override" @click.stop="bookAddon(row)">Boka tillval</button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      </div>

      <div v-if="orderTypeSingle !== 'accomodation'">
          <div class="other">
            <div class="other-image" :style="'background-image:url(' + 'https://cdn.branasgruppen.se/branas/app/uploads/2023/10/27141148/familjmedskidor_hero.jpg' + ');'">
            </div>

            <div class="booking-facts">
              <div>
              <p class="booking-id">
                Bokningsnummer: {{ order.resvid }}
              </p>

              <p class="booking-title">
                {{ orderTypeVisual }}
              </p>

              <p class="arrival-date">
                {{order.details.firstDate | date('long', ' – ')}}
              </p>
              </div>

              <div>
                <button class="book-more" @click.stop="goToBooking(order.headlid)">Visa bokning</button>
              </div>
            </div>
          </div>
          <PrettyOrderDetails :order="order" :types="['rental', 'skipass', 'skischool']" :openRental="true" :openSkipass="true" :openSkischool="true" :bookMoreCallback="bookMoreCb" />
        </div> 
    </div>
  </div>
</template>

<script>
import UnitFacts from '@/components/parts/Accomodation/UnitFacts';
import CompletedBookings from '@/components/parts/CompletedBookings';
import PrettyOrderDetails from '@/components/components/PrettyOrderDetails';

import myOrder from '@/mixins/my-order'; // eslint-disable-line

export default {
  props: {
    order: {
      default: {},
    },
    bookMoreCallback: {
      default: () => {},
    },
  },
  components: {
    UnitFacts,
    CompletedBookings,
    PrettyOrderDetails,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
  },
  mixins: [myOrder],
  methods: {
    followLink(linkObject) {
      const method = linkObject.function[0];
      const argument = linkObject.function[1];

      if (method === 'goToBooking') {
        this.goToBooking(argument);
      } else if (method === 'bookMore') {
        this.bookMore(argument);
      } else if (method === 'goToAccommodation') {
        this.goToAccommodation(argument);
      } else if (method === 'bookAddon') {
        this.bookAddon(argument);
      } else if (method === 'goToLink') {
        window.open(argument, '_blank');
      }
    },
    goToBooking(no) {
      this.$router.push({ name: 'my journey booking', params: { bookingNumber: no } });
    },
    bookMore(no) {
      this.$router.push({ name: 'my journey booking', params: { bookingNumber: no, onlyMore: true } });
    },
    goToAccommodation(slug) {
      const url = this.$route.path.substr(1);
      this.$router.push({ path: `/mina-sidor/resa/boende/${slug}?flow=${url}` });
    },
    bookMoreCb(data, data2) {
      this.bookMoreCallback(data, data2);
    },
    bookAddon(row) {
      this.$store.state.cart.addToOrder = {
        number: this.order.resvid,
        numeric: this.order.headlid,
        accomodationRow: row.row,
        accomodationName: row.name,
        accomodationDateArrival: row.arrival,
        accomodationDateDeparture: row.departure,
        accomodationGroup: row.group,
      };

      this.$router.push({
        name: 'addons extra',
        query: {
          pool: row.pool,
          unit: row.unit,
          arrival: row.arrival,
          departure: row.departure,
          name: row.name,
          adults: parseInt(row.adults, 10),
          youths: parseInt(row.youths, 10),
          children: parseInt(row.children, 10),
          seniors: parseInt(row.seniors, 10) || 0,
        },
      });
    },
  },
  computed: {
    links() {
      let links = [];

      links.push({
        function: ['goToBooking', this.order.headlid],
        text: 'Visa detaljer',
        class: '',
      });

      if (this.order.details.can_add_to_booking && this.SITE_CONFIG.add_to_booking_open) {
        links.push({
          function: ['bookMore', this.order.headlid],
          text: 'Lägg till',
          class: 'white',
        });
      }

      if (this.order.details.rows) {
        if (this.order.details.rows.accomodation && this.order.details.rows.accomodation.length) {
          let localLinks = this.order.details.rows.accomodation.map((row) => {
            let aName = 'boendet';
            if (this.order.details.rows.accomodation.length > 1) {
              aName = row.accommodation.display_name || row.accommodation.description_title;
            }

            return {
              function: ['goToAccommodation', row.accommodation.slug],
              text: `Läs mer om ${aName}`,
              class: 'white',
            };
          });

          links = links.concat(localLinks);

          localLinks = this.order.details.rows.accomodation.map((row) => {
            let aName = '';
            if (this.order.details.rows.accomodation.length > 1) {
              aName = row.accommodation.display_name || row.accommodation.description_title;
              aName = ` för ${aName}`;
            }

            if (this.order.details.can_add_to_booking && this.SITE_CONFIG.add_to_booking_open) {
              return {
                function: ['bookAddon', row],
                text: `Boka tillval${aName}`,
                class: 'white',
              };
            }

            return null;
          }).filter(a => a !== null);

          links = links.concat(localLinks);

          links.push({
            function: ['goToLink', 'https://www.branas.se/info-till-boendegast/'],
            text: 'Om att bo hos oss',
            class: 'white',
          });

          links.push({
            function: ['goToLink', 'https://www.branas.se/bra-att-veta__trashed/in-och-utcheckning/'],
            text: 'In- och utcheckning',
            class: 'white',
          });
        }

        if (this.order.details.rows.rental && this.order.details.rows.rental.length) {
          links.push({
            function: ['goToLink', 'https://www.branas.se/hyra-skidor/'],
            text: 'Om hyra',
            class: 'white',
          });
        }

        if (this.order.details.rows.skipass && this.order.details.rows.skipass.length) {
          links.push({
            function: ['goToLink', 'https://www.branas.se/skidakning-i-branas/liftkort/'],
            text: 'Om liftkort',
            class: 'white',
          });
        }

        if (this.order.details.rows.skischool && this.order.details.rows.skischool.length) {
          links.push({
            function: ['goToLink', 'https://www.branas.se/skidskola-i-branas/'],
            text: 'Om skidskola',
            class: 'white',
          });
        }

        if (this.order.status === 'upcoming') {
          links.push({
            function: ['goToLink', 'https://www.branas.se/bra-att-veta__trashed/infor-resan/'],
            text: 'Inför resan',
            class: 'white',
          });
        }
      }

      links.push({
        function: ['goToLink', 'https://www.branas.se/gastservice/kontakta-oss/'],
        text: 'Kontakt',
        class: 'white',
      });

      return links;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'
@import '~@/global-v2.styl'

.pretty-order
  box-shadow 0 20px 40px 0 rgba(0, 0, 0, 0.05)
  background-color white
  padding 0
  position relative
  margin-bottom 2rem
  font-size 1rem

.accommodation, .other
  display flex
  @media (max-width: 650px)
    flex-direction column

.accommodation-image, .other-image
  width 180px
  padding-top: 120px
  background-size: cover
  background-position: center
  @media (max-width: 650px)
    width 100% !important
.accommodation-image
  width 336px
  padding-top 224px

.booking-facts
  flex: 1
  padding 2rem 1.75rem 1.25rem 1.75rem
  @media(max-width 600px)
    flex-direction: column
    align-items: flex-start
    & > div:nth-child(2)
      margin-top 1rem

.other
  .booking-facts
    padding-top 1.75rem
    padding-bottom 1.75rem
    display flex
    justify-content: space-between
    align-items: center
    @media(max-width 600px)
      flex-direction: column
      align-items: flex-start
      & > div:nth-child(2)
        margin-top 1rem

.accommodation
  display flex
  .accommodation-image
    width 336px
    padding-top: 224px
    background-size: cover
  .booking-facts
    flex: 1
    padding 2rem 1.75rem 1.25rem 1.75rem

.booking-id
  barlow()
  margin 0

.booking-title
  medium-title()
  margin 0 0
  margin-top 0.5rem

.arrival-date
  barlow()
  margin 0

.book-more
  button--rounded--outlined()
</style>



// WEBPACK FOOTER //
// PrettyOrder.vue?0be2515a